const NavigationDots = ({ active }) => {
  return (
    <div className='app__navigation'>
      {[
        'olá', 'sobre', 'trabalhos', 'habilidades', 'depoimentos', 'contato'
      ].map((e, index) => (
        <a
          key={e + index}
          href={`#${e}`}
          className="app__navigation-dot"
          style={active === e ? {backgroundColor: '#4c9173'} : { }}
        />
      ))}
    </div>
  )
}

export default NavigationDots